import { render, staticRenderFns } from "./SendWhatsappModal.vue?vue&type=template&id=21000d90"
import script from "./SendWhatsappModal.vue?vue&type=script&lang=js"
export * from "./SendWhatsappModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports